import { render, staticRenderFns } from "./my-join-task.vue?vue&type=template&id=a948d038"
import script from "./my-join-task.vue?vue&type=script&lang=js"
export * from "./my-join-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports